import EmptyState from '@components/EmptyState'
import React from 'react'

interface Prop {
  buttonLabel?: string
  buttonLink?: string
  icon?: string
}

const EmptyLearningPath: React.FC<Prop> = ({ icon = '/images/lost.svg', buttonLabel = '', buttonLink = '' }) => (
  <EmptyState
    heading="No learning path available. Please contact your learning center or raise a case."
    img={icon}
    btnTxt={buttonLabel}
    linkUrl={buttonLink}
  />
)

export default EmptyLearningPath
